import { 
  PaymentMethod, 
  DbPaymentMethod, 
  PaymentMethodCreate, 
  PaymentMethodUpdate,
  DbPaymentMethodInsert,
  DbPaymentMethodUpdate 
} from '@/types/entities/paymentMethod';

// =================================================================
// Database to Frontend Mappers (snake_case -> camelCase)
// =================================================================

export function dbPaymentMethodToPaymentMethod(dbPaymentMethod: DbPaymentMethod): PaymentMethod {
  return {
    id: dbPaymentMethod.id,
    userId: dbPaymentMethod.user_id,
    name: dbPaymentMethod.name,
    description: dbPaymentMethod.description || undefined,
    isActive: dbPaymentMethod.is_active ?? true,
    isDefault: dbPaymentMethod.is_default ?? false,
    config: typeof dbPaymentMethod.config === 'object' && dbPaymentMethod.config !== null 
      ? dbPaymentMethod.config as Record<string, unknown>
      : {},
    createdAt: new Date(dbPaymentMethod.created_at),
    updatedAt: new Date(dbPaymentMethod.updated_at),
  };
}

// =================================================================
// Frontend to Database Mappers (camelCase -> snake_case)
// =================================================================

export function paymentMethodCreateToDbInsert(
  paymentMethodCreate: PaymentMethodCreate,
  userId: string
): DbPaymentMethodInsert {
  return {
    name: paymentMethodCreate.name,
    description: paymentMethodCreate.description || null,
    is_active: paymentMethodCreate.isActive ?? true,
    is_default: paymentMethodCreate.isDefault ?? false,
    config: paymentMethodCreate.config || {},
    user_id: userId,
  };
}

export function paymentMethodUpdateToDbUpdate(
  paymentMethodUpdate: PaymentMethodUpdate
): DbPaymentMethodUpdate {
  const dbUpdate: DbPaymentMethodUpdate = {};

  if (paymentMethodUpdate.name !== undefined) {
    dbUpdate.name = paymentMethodUpdate.name;
  }
  if (paymentMethodUpdate.description !== undefined) {
    dbUpdate.description = paymentMethodUpdate.description || null;
  }
  if (paymentMethodUpdate.isActive !== undefined) {
    dbUpdate.is_active = paymentMethodUpdate.isActive;
  }
  if (paymentMethodUpdate.isDefault !== undefined) {
    dbUpdate.is_default = paymentMethodUpdate.isDefault;
  }
  if (paymentMethodUpdate.config !== undefined) {
    dbUpdate.config = paymentMethodUpdate.config || {};
  }

  return dbUpdate;
}
